module.exports = __webpack_public_path__ + "img/812.916c15e1.png";